import axios from 'axios';

import { getAuth } from 'firebase/auth';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// console.log("BASE_URL:", BASE_URL);

const getAuthHeaders = async () => {
  const user = getAuth().currentUser;
  if (user) {
    const token = await user.getIdToken();
    // console.log("Token being sent:", token);
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return {};
};


// Function to send standard files to the `stdLevelCalculator` endpoint to calculate levels(priority)
export const calculateStdLevelAPI = async (transformedData) => {
  try {
    const config = await getAuthHeaders();
    const response = await axios.post(`${BASE_URL}/stdLevelCalculator`, {
      data: transformedData,
    }, config);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


// Function to send standard x and y to the `peakFinder` endpoint to calculate peaks
export const peakFinderAPI = async (x, y) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/peakFinder`, { x: x , y: y }, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};


// Function to send data to the `resultCreator` endpoint to create result object
export const resultCreatorAPI = async (x, y, peaksIndices, peaksXValues) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/resultCreator`, { x: x , y: y, peaksIndices:peaksIndices, peaksXValues:peaksXValues }, config);
        return response.data;
        
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

// Function to send data to the `reportingPeaks` endpoint to detect peaks for the maximum standard file
export const reportingPeaksDetectorAPI = async (stdFilesWithXPeaksObj, maximumStandardName, NumMinSamples, maxEps) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/reportingPeaks`, { stdFilesWithXPeaksObj: stdFilesWithXPeaksObj, maximumStandardName: maximumStandardName, NumMinSamples: NumMinSamples, maxEps: maxEps }, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to send data to the `peakClustering` endpoint to detect all peaks of uploaded files
export const peakClusteringAPI = async (allXPeaks, maxStdXPeaks, minStdXPeaks, NumMinSamples, maxEps) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/peakClustering`, { allXPeaks: allXPeaks, maxStdXPeaks: maxStdXPeaks, minStdXPeaks:minStdXPeaks, NumMinSamples:NumMinSamples, maxEps:maxEps}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to send files to the `xRangeOptimize` endpoint to optimize x ranges of uploaded files
export const xRangeOptimizerAPI = async (data) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/xRangeOptimize`, { data: data}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to send files to the `sigmaGammaEst` endpoint to estimate sigma and gamma
export const sigmaGammaEstimatorAPI = async (data) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/sigmaGammaEst`, { data: data}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to 
export const peakUpdate2API = async (data, allReportingPeaks) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/peakUpdate2`, { data: data, allReportingPeaks: allReportingPeaks}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to 
export const peakUpdate3API = async (data, buggingPeaks) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/peakUpdate3`, { data: data, buggingPeaks: buggingPeaks}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

// Function to send files to the `peakProcessing` endpoint to to precess the peaks and return area under peaks
export const peakProcessingAPI = async (data, sigma_list, gamma_list) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/peakProcessing`, { data: data, sigma_list: sigma_list, gamma_list: gamma_list}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}
// Function to send standard_peak_area, target_dict to the `tcpredictor` endpoint to to predict other TC values
export const targetConcentrationPredictorAPI = async (standard_peak_area, targets_object) => {
    try {
        const config = await getAuthHeaders();
        const response = await axios.post(`${BASE_URL}/tcpredictor`, { standard_peak_area: standard_peak_area, targets_object: targets_object}, config);
        return response.data;
     
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}
